<template>
  <ModalMiddle :title="t('setting')" :is-blurred="false" @close="onClickCancel">
    <AuxiliaryDisplayControlScreen ref="refAuxiliaryDisplayControlScreen" :is-global="true" />

    <div class="wrapper-buttons">
      <ButtonProcess full-width @click="saveSettings">
        {{ t('keep_current_settings') }}
      </ButtonProcess>
    </div>
  </ModalMiddle>
</template>

<script setup lang="ts">
import { onMounted, useTemplateRef } from 'vue';
import { useI18n } from 'vue-i18n';

import AuxiliaryDisplayControlScreen from '@/components/domains/chat/chat-general/AuxiliaryDisplayControlScreen.vue';
import ButtonProcess from '@/components/shared/base/ButtonProcess.vue';
import ModalMiddle from '@/components/shared/composite/ModalMiddle.vue';
import { usePreferences } from '@/composables/shared/usePreferences';
import { useToastStore } from '@/stores/toast';
import { useUserStore } from '@/stores/user';

const emit = defineEmits(['close']);

const { t } = useI18n();
const { isValidPreference } = usePreferences();
const toastStore = useToastStore();
const userStore = useUserStore();

const refAuxiliaryDisplayControlScreen = useTemplateRef('refAuxiliaryDisplayControlScreen');

const onClickCancel = () => {
  emit('close');
};

const saveSettings = () => {
  const settingsScreen = refAuxiliaryDisplayControlScreen.value?.payloadMessageFc.screenAttribute;

  if (!settingsScreen || !isValidPreference(settingsScreen)) return;

  localStorage.setItem('settings_screen', JSON.stringify(settingsScreen));

  toastStore.info(t('alert_save_completed'));
  emit('close');
};

onMounted(() => {
  userStore.setupUserPreferences('settings_screen');
});
</script>

<style scoped lang="scss">
.wrapper-buttons {
  width: 100%;
  margin-top: 1rem;
}

.dropdown-trigger {
  display: flex;
  width: 100%;
  gap: 0.5rem;
  justify-content: center;
  padding: 0.75rem;
  background-color: var(--surface-default);
  border-radius: 8px;
  cursor: pointer;
}

.dropdown-trigger:hover,
.dropdown-trigger:active,
.dropdown-trigger.active {
  background-color: var(--surface-gray-dim);
}

::v-deep(.dropdown-content) {
  width: 77dvw;
  max-width: 21rem;
}

.language-container {
  width: 100%;
  position: relative;
}

.language-options {
  position: absolute;
  width: 100%;
  z-index: 999;
  max-height: 300px;
  overflow-y: auto;
}
</style>
